(function (f) {
  if (typeof exports === "object" && typeof module !== "undefined") {
    module.exports = f();
  } else if (typeof define === "function" && define.amd) {
    define([], f);
  } else {
    var g;

    if (typeof window !== "undefined") {
      g = window;
    } else if (typeof global !== "undefined") {
      g = global;
    } else if (typeof self !== "undefined") {
      g = self;
    } else {
      g = this;
    }

    g.ErrorSubclass = f();
  }
})(function () {
  var define, module, exports;
  return function e(t, n, r) {
    function s(o, u) {
      if (!n[o]) {
        if (!t[o]) {
          var a = typeof require == "function" && require;
          if (!u && a) return a(o, !0);
          if (i) return i(o, !0);
          var f = new Error("Cannot find module '" + o + "'");
          throw f.code = "MODULE_NOT_FOUND", f;
        }

        var l = n[o] = {
          exports: {}
        };
        t[o][0].call(l.exports, function (e) {
          var n = t[o][1][e];
          return s(n ? n : e);
        }, l, l.exports, e, t, n, r);
      }

      return n[o].exports;
    }

    var i = typeof require == "function" && require;

    for (var o = 0; o < r.length; o++) {
      s(r[o]);
    }

    return s;
  }({
    1: [function (require, module, exports) {
      'use strict';

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      /* eslint-disable prefer-reflect */

      var ErrorSubclass = function ErrorSubclass() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var message = args[0];

        var _error = Error.apply(this, args);

        Object.defineProperty(this, 'message', {
          value: message
        });
        Object.defineProperty(this, 'name', {
          value: this.constructor.displayName || this.constructor.name
        });

        if (Error.captureStackTrace) {
          Error.captureStackTrace(this, this.constructor);
        } else {
          Object.defineProperty(this, 'stack', {
            get: function get() {
              return _error.stack;
            }
          });
        }
      };

      ErrorSubclass.prototype = Error.prototype;

      ErrorSubclass.prototype.toString = function toString() {
        return this.name + ': ' + this.message;
      };

      exports.default = ErrorSubclass;
    }, {}]
  }, {}, [1])(1);
});